import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Typography, Row, Col, Button, Space } from "antd";
import axiosInstance from "../../../configs";
import dayjs from "dayjs";
import "dayjs/locale/id";

dayjs.locale("id");

const { Title, Text } = Typography;

export default function IncomingPcPrint() {
    const { id } = useParams();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (id) {
            axiosInstance.get(`/incoming-pc/${id}/with-details`)
                .then(res => {
                    setData(res.data);
                })
                .catch(err => console.error(err))
                .finally(() => setLoading(false));
        }
    }, [id]);

    if (loading) return <div>Loading...</div>;
    if (!data) return <div>Data not found</div>;

    const { header, details } = data;

    const items = details || [];
    const formattedDate = header.tanggal_terima
        ? dayjs(header.tanggal_terima).format("D MMMM YYYY")
        : "-";

    // Header has nama_customer, stpc_number, etc.
    // Assuming backend returns { header: {...}, details: [...] } or checks existing format

    return (
        <div style={{ padding: 40, fontFamily: 'Arial, sans-serif', maxWidth: 900, margin: '0 auto', background: "white" }}>
            {/* Header / Kop */}
            <div style={{ textAlign: "center", marginBottom: 20 }}>
                <img
                    src="/assets/media/logos/alb.png"
                    alt="ALB Logo"
                    style={{ width: 100, display: "block", margin: "0 auto 10px auto" }}
                />
            </div>

            <div style={{ textAlign: "center", marginBottom: 30 }}>
                <Title level={4} style={{ margin: 0, textTransform: "uppercase", textDecoration: "underline" }}>
                    BERITA ACARA SERAH TERIMA PITA CUKAI
                </Title>
                <Text>Nomor BA: {header.stpc_number || "-"}</Text>
            </div>

            {/* Info Table */}
            <table style={{ width: "100%", marginBottom: 20, fontSize: 13, border: "none" }}>
                <tbody>
                    <tr>
                        <td style={{ width: 180, fontWeight: "bold" }}>Nomor Dokumen CK-1A</td>
                        <td style={{ width: 10 }}>:</td>
                        <td>{header.no_ck1a || "-"}</td>
                    </tr>
                    {/* <tr>
                        <td style={{ fontWeight: "bold" }}>Tanggal Dokumen</td>
                        <td>:</td>
                        <td>{header.tanggal_ck1a ? dayjs(header.tanggal_ck1a).format("DD-MM-YYYY") : "-"}</td>
                    </tr> */}
                    <tr>
                        <td style={{ fontWeight: "bold" }}>Tanggal Serah Terima</td>
                        <td>:</td>
                        <td>{formattedDate}</td>
                    </tr>
                    <tr>
                        <td style={{ fontWeight: "bold" }}>Importir</td>
                        <td>:</td>
                        <td>{header.nama_customer || "-"}</td>
                    </tr>
                </tbody>
            </table>

            <div style={{ marginBottom: 10, fontSize: 13 }}>
                <Text>Telah dilaksanakan serah terima pita cukai dengan rincian sebagai berikut:</Text>
            </div>

            {/* Item Table */}
            <table style={{ width: "100%", borderCollapse: "collapse", border: "1px solid #000", marginBottom: 20, fontSize: 12 }}>
                <thead>
                    <tr style={{ backgroundColor: "#f0f0f0" }}>
                        {/* <th style={{ border: "1px solid #000", padding: "6px", textAlign: "center", width: 40 }}>No.</th> */}
                        <th style={{ border: "1px solid #000", padding: "6px", textAlign: "left" }}>Seri</th>
                        <th style={{ border: "1px solid #000", padding: "6px", textAlign: "left" }}>Golongan</th>
                        <th style={{ border: "1px solid #000", padding: "6px", textAlign: "center" }}>Isi (ml)</th>
                        <th style={{ border: "1px solid #000", padding: "6px", textAlign: "center" }}>Jml Keping</th>
                        <th style={{ border: "1px solid #000", padding: "6px", textAlign: "center" }}>Jml Lembar</th>
                    </tr>
                </thead>
                <tbody>
                    {items.map((item, index) => (
                        <tr key={index}>
                            {/* <td style={{ border: "1px solid #000", padding: "6px", textAlign: "center" }}>{index + 1}</td> */}
                            <td style={{ border: "1px solid #000", padding: "6px" }}>{item.seri || "-"}</td>
                            <td style={{ border: "1px solid #000", padding: "6px" }}>{item.golongan || "-"}</td>
                            <td style={{ border: "1px solid #000", padding: "6px", textAlign: "center" }}>{item.isi || "-"}</td>
                            <td style={{ border: "1px solid #000", padding: "6px", textAlign: "center" }}>{item.jumlah_keping || item.keping}</td>
                            <td style={{ border: "1px solid #000", padding: "6px", textAlign: "center" }}>{item.jumlah_lembar || item.lembar}</td>
                        </tr>
                    ))}
                    {items.length === 0 && (
                        <tr>
                            <td colSpan={6} style={{ textAlign: "center", padding: 10 }}>Tidak ada detail</td>
                        </tr>
                    )}
                </tbody>
            </table>

            <div style={{ marginBottom: 20, fontSize: 13 }}>
                <Text>Total Keping: {header.total_keping}</Text><br />
                <Text>Total Lembar: {header.total_lembar}</Text>
            </div>

            {/* Signatures */}
            <Row style={{ marginTop: 50, fontSize: 12 }}>
                <Col span={8} style={{ textAlign: "center" }}>
                    <div>Diserahkan Oleh,</div>
                    <div style={{ marginTop: 70, borderBottom: "1px solid #000", width: "80%", margin: "70px auto 0 auto" }}></div>
                    <div>(Pihak Importir)</div>
                </Col>
                <Col span={8} style={{ textAlign: "center" }}>
                    <div>Diterima Oleh,</div>
                    <div style={{ marginTop: 70, borderBottom: "1px solid #000", width: "80%", margin: "70px auto 0 auto" }}></div>
                    <div>(Petugas Gudang)</div>
                </Col>
                <Col span={8} style={{ textAlign: "center" }}>
                    <div>Mengetahui,</div>
                    <div style={{ marginTop: 70, borderBottom: "1px solid #000", width: "80%", margin: "70px auto 0 auto" }}></div>
                    <div>(Petugas Bea Cukai)</div>
                </Col>
            </Row>

            <style>{`
                @media print {
                    .print-controls { display: none !important; }
                    @page { margin: 2cm; }
                    body { -webkit-print-color-adjust: exact; background: white; }
                }
            `}</style>

            <div className="print-controls" style={{ marginTop: 40, textAlign: 'center' }}>
                <Button type="primary" onClick={() => window.print()}>Print / Cetak</Button>
            </div>
        </div>
    );
}
